import React from 'react';
import { Dialog, DialogContent } from '@mui/material';

import { PopUpText } from '../../styledComponent/SignUpComponents.style';
import { MainButton } from '../../styledComponent/Buttons.style';

import { ErrorCode, ServerError } from './SignUp.types';

interface SignUpErrorPopUpProps {
  isPopUpOpen: boolean;
  setIsPopUpOpen: (value: boolean) => void;
  serverErrorMessage: ServerError | undefined;
  onClosePopUp: () => void;
}

export const SignUpErrorPopUp = ({
  setIsPopUpOpen,
  isPopUpOpen,
  serverErrorMessage,
  onClosePopUp,
}: SignUpErrorPopUpProps) => {
  return (
    <Dialog onClose={() => setIsPopUpOpen(false)} open={isPopUpOpen}>
      <DialogContent>
        <PopUpText>{serverErrorMessage?.message}</PopUpText>
        <MainButton onClick={onClosePopUp}>
          {serverErrorMessage?.errorCode === ErrorCode.Exists ? 'Log in' : 'Close'}
        </MainButton>
      </DialogContent>
    </Dialog>
  );
};
